export default __webpack_public_path__ + "static/media/menuL_on_icon_03.0025917a.png";